import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './Components/dashboard.component';

export const dashboardRouting: Routes = [
  {
    path: '',
    component: DashboardComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(dashboardRouting)],
  exports: [RouterModule],
})
export class DashboardRoutingModule {}
